'use client'

import React, { FC, PropsWithChildren, useMemo } from 'react'
import Link, { LinkProps } from 'next/link'
import { emitter, EVENT_SHOW_SIGN_IN_MODAL } from '@/events'
import { useUserStore } from '@/feature/user/store'

export interface AuthLinkProps extends LinkProps {
  className?: string
}

const AuthLink = (props: PropsWithChildren<AuthLinkProps>) => {
  const { href, ...restProps } = props
  const hasUserInfo = useUserStore((state) => state.userInfo)

  return hasUserInfo ? (
    <Link {...props} />
  ) : (
    <Link
      href=""
      {...restProps}
      onClick={() => {
        emitter.emit(EVENT_SHOW_SIGN_IN_MODAL)
      }}
    />
  )
}

export default AuthLink
